import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";

export interface PortfolioSummaryData {
  portfolioValue?: number | null;
  cashBalance?: number | null;
  availableMargin?: number | null;
  holdingsCount?: number | null;
  openPositionsCount?: number | null;
  lastUpdated?: string | null;
}

interface PortfolioSummaryCardProps {
  data: PortfolioSummaryData;
}

/**
 * Renders exactly the fields the backend supplies. Today's `/api/v1/portfolio`
 * contract has no persisted read side (TD-083), so every field here is
 * "Not reported by backend" until a caller-supplied snapshot is available -
 * this component never derives a value on its own.
 */
export function PortfolioSummaryCard({ data }: PortfolioSummaryCardProps): React.JSX.Element {
  return (
    <StatusCard title="Portfolio Summary">
      <Stack spacing={1.5}>
        <MetricCard label="Portfolio Value" value={data.portfolioValue} />
        <MetricCard label="Cash Balance" value={data.cashBalance} />
        <MetricCard label="Available Margin" value={data.availableMargin} />
        <MetricCard label="Holdings Count" value={data.holdingsCount} />
        <MetricCard label="Open Positions" value={data.openPositionsCount} />
        <MetricCard label="Last Updated" value={data.lastUpdated} />
      </Stack>
    </StatusCard>
  );
}
